export const isCKLAPilotDomainDisabled = () => {
  const today = new Date();
  const targetDate = new Date(2025, 6, 1); // Note: Months are 0-indexed, so 6 represents July

  return today > targetDate;
};
